const actionsDisabledMessageCls = "_275a1amafat";
const wrapperCls = "_275w65i9e7";
const table = "_275t1o9zdgx";
const row = "_275r18e1mqk";

export { actionsDisabledMessageCls, row, table, wrapperCls };
import "./course-table.style.linaria.module.css";
//# sourceMappingURL=course-table.style.js.map
